import { render } from "./DealRecoverRule.vue?vue&type=template&id=3a6192ac&scoped=true"
const script = {}

import "./DealRecoverRule.vue?vue&type=style&index=0&id=3a6192ac&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a6192ac"]])

export default __exports__